import type { CityConfig } from "../city-template/types";

export const marionConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Ohio Department of Health", href: "https://odh.ohio.gov/know-our-programs/vital-statistics", description: "Official Ohio vital records office in Columbus" },
    { label: "Marriage Licenses — Marion County Probate Court", href: "https://www.co.marion.oh.us/probate-court", description: "Marion County Probate Judge — marriage license issuance" },
    { label: "Divorce Records — Marion County Clerk of Courts", href: "https://www.co.marion.oh.us/clerk-of-courts", description: "Marion County Clerk of Courts — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Ohio Department of Health for online vital record orders" },
  ],
  city: "Marion",
  state: "Ohio",
  stateAbbr: "OH",
  slug: "marion-oh",
  route: "/marion-oh",
  title: "Emergency Passport Marion, OH — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Marion, OH — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Marion County and north-central Ohio. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Marion, OH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Marion and north-central Ohio travelers — including Prospect, Waldo, and Caledonia — get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Marion%20Ohio%20downtown%20historic%20district%20with%20classic%20American%20architecture%2C%20charming%20main%20street%20with%20brick%20buildings%20and%20historic%20courthouse%2C%20warm%20afternoon%20light%20on%20a%20small%20town%20Ohio%20cityscape%2C%20tree-lined%20streets%20with%20well-preserved%20historic%20buildings%2C%20professional%20photography%20with%20warm%20earth%20tones%20and%20a%20peaceful%20atmosphere&width=1800&height=700&seq=marion-oh-hero-001&orientation=landscape",
  heroImageAlt: "Marion Ohio historic downtown district with classic architecture",
  geoPosition: "40.5887;-83.1285",
  geoPlacename: "Marion, Ohio",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 270 miles from Marion via I-80",
  },
  nearbyCitiesZips: [
    { name: "Marion", zips: "43301–43307" },
    { name: "Prospect", zips: "43342" },
    { name: "Waldo", zips: "43356" },
    { name: "Caledonia", zips: "43314" },
    { name: "Bucyrus", zips: "44820" },
    { name: "Upper Sandusky", zips: "43351" },
    { name: "Mount Gilead", zips: "43338" },
    { name: "Kenton", zips: "43326" },
    { name: "Bellefontaine", zips: "43311" },
    { name: "Delaware", zips: "43015" },
    { name: "Marysville", zips: "43040" },
    { name: "Crestline", zips: "44827" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Marion departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-global-line", title: "North-Central Ohio Coverage", desc: "Serving Marion, Crawford, and Morrow County travelers" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Columbus, OH", route: "/columbus-oh" },
    { name: "Fast passport renewal in Mansfield, OH", route: "/mansfield" },
    { name: "Emergency passport help in Findlay, OH", route: "/findlay" },
    { name: "Urgent passport services in Delaware, OH", route: "/delaware-oh" },
    { name: "Same-day passport help in Dayton, OH", route: "/dayton" },
    { name: "Passport courier services in Newark, OH", route: "/newark-oh" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Marion remotely via secure courier. We do not have a walk-in office in Marion — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Marion County and north-central Ohio travelers.",
  fpcOfficeDistance: "Serving all of Marion County and north-central Ohio",
  fpcOfficeAddress: "175 S Third St, Ste 200, Columbus, Ohio 43215",
  serviceAreaIntro: "From downtown Marion to Prospect and Waldo, from Caledonia to Bucyrus and Upper Sandusky — Fast Passport Center serves the entire north-central Ohio region. We regularly help travelers from Marion, Crawford, and Morrow counties get their passports fast.",
  nearbyCitiesIntro: "We serve all Marion neighborhoods and the surrounding north-central Ohio region including Prospect, Waldo, Caledonia, Bucyrus, Upper Sandusky, Mount Gilead, Kenton, Bellefontaine, Delaware, Marysville, and Crestline. If you are anywhere in the Marion area or north-central Ohio, we have you covered.",
  howItWorksIntro: "Most Marion travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Marion travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Marion and north-central Ohio travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Marion? Here are the most common ones we hear from Marion County travelers.",
  statePageRoute: "/states/ohio",
  statePageName: "Ohio",
  dmvWebsite: "https://www.bmv.ohio.gov",
  dmvLabel: "Ohio BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Marion international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Thomas H.",
      location: "Marion, OH",
      rating: 5,
      text: "My passport expired two weeks before my business trip to Vancouver. Fast Passport Center had my renewal ready in 4 days. They were professional and kept me updated every day.",
      service: "Passport Renewal",
    },
    {
      name: "Angela B.",
      location: "Prospect, OH",
      rating: 5,
      text: "Family emergency required me to fly to London within 48 hours. Fast Passport Center got my emergency passport processed in under 36 hours. Truly a lifesaver.",
      service: "Emergency Passport",
    },
    {
      name: "Gregory S.",
      location: "Bucyrus, OH",
      rating: 5,
      text: "Applied for my son's first passport for our cruise to the Bahamas. They found the nearest acceptance facility and had his passport ready in 6 days. Excellent service.",
      service: "Child Passport",
    },
    {
      name: "Patricia W.",
      location: "Waldo, OH",
      rating: 5,
      text: "Lost my passport the week before my Cancun trip. Fast Passport Center handled the DS-64 form and got me a replacement in 4 days. I was so relieved.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "marion-1",
      name: "Marion Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "220 Barks Rd E",
      city: "Marion",
      state: "OH",
      zip: "43302",
      phone: "(740) 387-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "East Marion",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main Marion facility. High volume — appointments strongly recommended. Call ahead for availability.",
      icon: "ri-mail-line",
    },
    {
      id: "marion-2",
      name: "Marion Downtown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "320 W Center St",
      city: "Marion",
      state: "OH",
      zip: "43302",
      phone: "(740) 387-2512",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Marion",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for downtown Marion residents. Less crowded than the main facility. Call for appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "marion-3",
      name: "Bucyrus Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "124 S Walnut St",
      city: "Bucyrus",
      state: "OH",
      zip: "44820",
      phone: "(419) 562-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Crawford County, 15 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Crawford County residents. Ample parking. Call ahead for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "marion-4",
      name: "Kenton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "111 N Detroit St",
      city: "Kenton",
      state: "OH",
      zip: "43326",
      phone: "(419) 675-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Hardin County, 25 miles west",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative for west Marion and Hardin County residents. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "marion-5",
      name: "Marion County Clerk of Courts",
      type: "Court Clerk Passport Acceptance",
      address: "100 N Main St",
      city: "Marion",
      state: "OH",
      zip: "43302",
      phone: "(740) 223-4100",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Marion County Courthouse",
      website: "https://www.co.marion.oh.us/",
      websiteLabel: "Marion County Courts",
      notes: "Accepts passport applications. Good alternative to post office with extended hours and appointment availability.",
      icon: "ri-government-line",
    },
    {
      id: "marion-6",
      name: "Upper Sandusky Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "125 N Sandusky Ave",
      city: "Upper Sandusky",
      state: "OH",
      zip: "43351",
      phone: "(419) 294-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Wyandot County, 20 miles northwest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Wyandot County residents northwest of Marion. Call for appointment.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4.5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Marion photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Marion County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Marion applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Marion County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Marion travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Marion." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Marion address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Marion before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Marion for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4.5 hour drive to Chicago." },
    { q: "How fast can I renew my passport in Marion?", a: "Fast Passport Center offers fast passport renewal in Marion in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "Can I get a same-day passport appointment near Marion?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 270 miles from Marion via I-80 — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Marion County residents." },
    { q: "Can I expedite a child passport in Marion?", a: "Yes. Fast Passport Center expedites child passports in Marion for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Marion County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Marion with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "What is the closest passport agency to Marion?", a: "The nearest regional passport agency to Marion is the Chicago Passport Agency, approximately 270 miles away via I-80. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Marion without any in-person agency visit required." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Can you help travelers from Bucyrus and Upper Sandusky?", a: "Absolutely. Fast Passport Center serves all of Marion County and the surrounding north-central Ohio region including Bucyrus, Upper Sandusky, Mount Gilead, Kenton, Bellefontaine, Delaware, Marysville, and Crestline. Our courier service works seamlessly from any zip code in the area." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Marion", address: "1480 Marion-Mt Gilead Rd, Marion, OH 43302", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Marion", address: "1250 Delaware Ave, Marion, OH 43302", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Marion", address: "1546 Marion-Mt Gilead Rd, Marion, OH 43302", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Rite Aid — Marion", address: "1100 N Main St, Marion, OH 43302", hours: "Mon–Sun: 9AM–9PM" },
    { name: "CVS Pharmacy — Bucyrus", address: "1200 E Mansfield St, Bucyrus, OH 44820", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Kenton", address: "1474 E US-68, Kenton, OH 43326", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart — Delaware", address: "1760 Columbus Pike, Delaware, OH 43015", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Marysville", address: "1600 N Main St, Marysville, OH 43040", hours: "Mon–Sun: 8AM–10PM" },
  ],
  dmvLocations: [
    {
      name: "Marion BMV — Marion County",
      address: "222 Barks Rd E, Marion, OH 43302",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "Bucyrus BMV — Crawford County",
      address: "225 S Spring St, Bucyrus, OH 44820",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Crawford County driver's license and REAL ID services. Alternative for south Marion residents.",
      featured: false,
    },
    {
      name: "Kenton BMV — Hardin County",
      address: "114 S Main St, Kenton, OH 43326",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Hardin County BMV. Alternative for west Marion and Kenton area residents.",
      featured: false,
    },
    {
      name: "Delaware BMV — Delaware County",
      address: "1005 Pittsburgh Dr, Delaware, OH 43015",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Delaware County BMV. Alternative for southeast Marion and Delaware area residents.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "MNN",
      name: "Marion Municipal Airport",
      distance: "3 miles from downtown Marion",
      address: "1500 League Rd, Marion, OH 43302",
      note: "Regional airport serving north-central Ohio with general aviation and charter services. Commercial flights connect through Columbus and Dayton.",
      flightUrl: "https://www.marionohio.us/",
      flightLabel: "Marion Airport",
      featured: true,
    },
    {
      code: "CMH",
      name: "John Glenn Columbus International Airport",
      distance: "55 miles south of Marion",
      address: "4600 International Gateway, Columbus, OH 43219",
      note: "Nearest major commercial airport with direct flights to major hubs. Primary airport for Marion international travelers.",
      flightUrl: "https://www.flycmh.com/",
      flightLabel: "Columbus Airport",
      featured: false,
    },
    {
      code: "DAY",
      name: "Dayton International Airport",
      distance: "95 miles southwest of Marion",
      address: "3600 Terminal Dr, Dayton, OH 45377",
      note: "Alternative airport for southwest Marion. Additional flight options and sometimes easier parking.",
      flightUrl: "https://flydayton.com/",
      flightLabel: "Dayton Airport",
      featured: false,
    },
  ],
};